// client/src/components/chat/ItemShareCard.js
import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const COLLECTION_TO_ITEM_TYPE = {
  games: 'game', consoles: 'console', lego: 'lego',
  movies: 'movie', music: 'music', books: 'book', 'board-games': 'board-game',
};

export default function ItemShareCard({ item }) {
  if (!item) return null;
  const itemType = COLLECTION_TO_ITEM_TYPE[item.collectionType] || item.itemType;
  const itemUrl = itemType && item.itemId ? `/item/${itemType}/${item.itemId}` : null;

  return (
    <Box
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 1.5,
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 2, p: 1,
        bgcolor: 'rgba(124,140,255,0.06)',
        backdropFilter: 'blur(8px)',
        maxWidth: 340,
      }}
    >
      {item.itemImage && (
        <Box component="img" src={item.itemImage} alt={item.itemName}
          sx={{ width: 44, height: 44, objectFit: 'cover', borderRadius: 1, flexShrink: 0 }} />
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {item.itemName || 'Unknown item'}
        </Typography>
        {item.collectionType && (
          <Chip label={item.collectionType} size="small" sx={{ height: 16, fontSize: '0.6rem', mt: 0.25 }} />
        )}
      </Box>
      {itemUrl && (
        <Button component={Link} to={itemUrl} size="small" endIcon={<OpenInNewIcon fontSize="inherit" />}
          sx={{ flexShrink: 0, minWidth: 0 }}>
          View
        </Button>
      )}
    </Box>
  );
}
